import { z } from "zod";

export const CreateJSASchema = z.object({
  title: z.string().min(1, "Title is required"),
  reference: z.string().optional(),
  siteId: z
    .object({ label: z.string(), value: z.string() })
    .nullable()
    .optional(),
  workLocation: z.string().optional(),
  responsiblePersonId: z
    .object({ label: z.string(), value: z.string() })
    .nullable()
    .optional(),
  teamMembers: z
    .array(z.object({ label: z.string(), value: z.string() }))
    .optional(),
  jobDescription: z.string().optional(),
  equipmentRequired: z.string().optional(),
  plannedStartDate: z.date({
    required_error: "Planned start date is required",
  }),
  plannedEndDate: z.date({
    required_error: "Planned end date is required",
  }),
  type: z.number().optional(),
  riskMatrixId: z
    .object({ label: z.string(), value: z.string() })
    .nullable()
    .optional(),
  steps: z
    .array(
      z.object({
        stepNumber: z.number(),
        stepDescription: z.string().min(1, "Step description is required"),
        hazards: z
          .array(
            z.object({
              riskRegisterEntryId: z
                .object({ label: z.string(), value: z.string() })
                .nullable()
                .optional(),
              customHazardDescription: z.string().optional(),

              // Scoring (Step 3)
              initialLikelihoodId: z.string().optional(),
              initialConsequenceId: z.string().optional(),
              initialScore: z.number().optional(),
              initialRiskLevelId: z.string().optional(),

              controlsApplied: z
                .array(
                  z.object({
                    riskRegisterControlId: z
                      .object({ label: z.string(), value: z.string() })
                      .nullable()
                      .optional(),
                    customControlDescription: z.string().optional(),
                    hierarchy: z.number().optional(),
                  }),
                )
                .optional(),

              residualLikelihoodId: z.string().optional(),
              residualConsequenceId: z.string().optional(),
              residualScore: z.number().optional(),
              residualRiskLevelId: z.string().optional(),
            }),
          )
          .optional(),
      }),
    )
    .optional(),
});

export type TCreateJSA = z.infer<typeof CreateJSASchema>;
